export const actionType = {
  SET_USER: "SET_USER",
  SET_PRODUCT: "SET_PRODUCT",
  SET_STAFFS: "SET_STAFFS",

};

const reducer = (state, action) => {
  console.log(action);

  switch (action.type) {
    case actionType.SET_USER:
      return {
        ...state,
        user: action.user,
      };
    case actionType.SET_PRODUCT:
      return {
        ...state,
        Products: action.Products,
      };
    case actionType.SET_STAFFS:
      return {
        ...state,
        staffs: action.staffs,
      };  
  
    default:
      return state;
  }
};

export default reducer;
